"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LessonModuleProvider = void 0;
const BaseDataProvider_1 = require("./BaseDataProvider");
class LessonModuleProvider extends BaseDataProvider_1.BaseDataProvider {
    module(groupId, id) {
        return this.docPromise(this.refs.lessonModule(groupId, id));
    }
    moduleForGroup(groupId, archived) {
        return this.collectionPromise(this.moduleForGroupQuery(groupId, archived));
    }
    getCanvasModule(groupId) {
        const query = this.refs.lessonModules(groupId).where('name', '==', 'canvas').orderBy('order', 'asc').limitToLast(1);
        return this.firstAsDocPromise(query);
    }
    async lastModuleForGroup(groupId, archived) {
        const query = this.moduleForGroupQuery(groupId, archived).limitToLast(1);
        return this.firstAsDocPromise(query);
    }
    moduleForGroupStream(groupId, archived) {
        return this.collectionDataStream(this.moduleForGroupQuery(groupId, archived), false);
    }
    moduleForGroupQuery(groupId, archived) {
        return this.refs.lessonModules(groupId).where('archived', '==', archived).orderBy('order', 'asc');
    }
}
exports.LessonModuleProvider = LessonModuleProvider;
//# sourceMappingURL=LessonModuleProvider.js.map